import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";
import { serviceWorkerStarten } from "@/lib/pwa";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

// index.html hat vor dem Start geprueft, ob Speicher und Cookies gesperrt
// sind (Safari "Alle Cookies blockieren"). Dann steht dort schon die
// Anleitung - React wuerde sie nur mit einer weissen Seite ueberschreiben.
if (window.__crmGesperrt) {
  throw new Error("CRM gesperrt: Speicher oder Cookies blockiert - Hinweis steht auf der Seite.");
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);

// Die App-Huelle: macht das CRM auf dem Handy installierbar und nimmt
// Push-Meldungen an. Laeuft nur im Produktionsbuild (lib/pwa.js).
serviceWorkerStarten();
